import React from 'react';
import ReactDOM from 'react-dom';
// from general.js
/* global dcAnalytics readCookie userId Handlebars loader   */
// from JSP?
/* global proposalId teacherScreenName proposalURL getTrackingLink */

import './DonorProposalMessageForm.tmpl.js';
import './proposalMessageFormPreview.tmpl.js'; // This is embedded in DonorProposalMessageForm.tmpl
import './proposalMessage.tmpl.js';
import './proposalMessageResponse.tmpl.js'; // This is both used directly and embedded in proposalMessage.tmpl
import './TeacherProposalMessageForm.tmpl.js';
import './proposalMessageHelpers.js'; // registers Handlebars helpers for the above templates

import { cancelDonorMessage, previewDonorMessage, strip } from './ProposalMessageFormFunctions.js';
import { FacebookLink } from '../common/FacebookLink.js';


// To leave a comment, the userId cookie's id and hash should match.
// we could query the server for the information needed to render the "leave a comment" form each time this page is loaded and let
// the server check if the current user is allowed to leave a comment. that would generate a server request on each page load, which,
// in some cases, could be avoided. more specifically, the availability of certain query string parameters / cookies combined with our
// knowledge of the people permitted to leave a comment, can tell us with certainty if a user is *not* allowed to leave a comment, in
// which case we can skip asking the server. this function is used to filter out the situations where we don't need to ask the server,
// because we already know that the user is *not* allowed to leave a comment.

// This function is only used by our JS tests, which have been broken for years
export function userIsPermittedMessageAuthor(userId, permittedMessageAuthorIds) {
    return $.inArray(userId.toString(), permittedMessageAuthorIds) > -1;
}

// if the userId cookie contains userId and hash, then it's worth confirming on the server that they match
// in new auth scheme, we don't care about the hash
export function cookiesIndicateThatUserIsFullyAuthenticated(userId) {
    return readCookie('userId') != null && userId != null && userId != '';
}

export function shouldWeQueryTheServerForProposalMessageFormModel(pmaId, pmaHash, salutation) {
    if (salutation == null) {
        return false;
    }

    if (!!pmaId && !!pmaHash) {
        // we still need to ask the server, because the hash could be wrong
        return true;
    }

    // If cookies indicate the user is auth'd, we still need to query the server,
    // because the user could be logged out, e.g. they sign out in a different tab
    return cookiesIndicateThatUserIsFullyAuthenticated(userId);
}

export function userCameToPageFromTYPCoverLetter(utmCampaign) {
    return utmCampaign === 'typ_cover';
}

// DONOR REPLY FORM FUNCTIONS

export function renderDonorProposalMessageForm(model) {
    const templateV = Handlebars.templates['DonorProposalMessageForm.tmpl'];
    const context = model;
    context.author = $.parseJSON($('body').data('userAuthor'));
    const htmlV = templateV(context);

    // sometimes the form is being added twice
    if ($('#donor-proposal-message-form .comment-form').length === 0) {
        $('#donor-proposal-message-form').append(htmlV);
        $('.js-donor-comment-form .js-preview-message').on('click', (e) => { e.preventDefault(); previewDonorMessage(); });
        $('.js-donor-comment-form .js-publish-button').on('click', (e) => { e.preventDefault(); publishDonorMessage(); });
        $('.js-donor-comment-form .js-cancel-button').on('click', (e) => { e.preventDefault(); cancelDonorMessage(); });
    }
    $('.js-donor-comment-form').hide();
}

function saveDonorProposalMessageCallback(response) {
    $('.loader.page-loader').remove();
    $('#leave-message-link').show();
    if (!response || !response.success) {
        $('#proposalMessageFormSubmissionErrors').html(response.message);
        $('#replyLoading').remove();
        $('#donor-proposal-message-form').show();
        // The definition of editDonorMessage was removed in
        // https://github.com/donorsChoose/donorschoose-web/commit/c811ffe520985799e4472d99ce5b1d9fef2b8011
        // Do we want to restore it?
        // editDonorMessage();
    } else {
        const templateV = Handlebars.templates['proposalMessage.tmpl'];
        const context = { original: response.data };
        const htmlV = templateV(context);
        $('#activity').prepend(htmlV);
        $('#donor-proposal-message-form').remove();
    }
}

function saveDonorProposalMessage(message) {
    $.ajax({
        // This is a cross-origin request because the endpoint accesses user session
        url: `${secureBaseURL}internal/project/${proposalId}/message/new.json`,
        method: 'GET',
        data: {
            message: message,
            parentMessageId: '',
            userId: window.pmaId || '',
            userHash: window.pmaHash || '',
        },
        // withCredentials is necessary to pass cookies, since this is a cross-origin request
        xhrFields: { withCredentials: true },
        success: saveDonorProposalMessageCallback,
    });
    $('#donor-proposal-message-form').hide();
    loader.showPageLoader();
}

function publishDonorMessage() {
    dcAnalytics.trackEventGA(['Proposal Message', 'Add', proposalId]);
    $('#buttonList').hide();
    saveDonorProposalMessage($('#message').val());
}

// TEACHER REPLY FORM FUNCTIONS

export function renderTeacherProposalMessageForm(container, idOfMessageBeingRepliedTo, nameOfUserBeingRepliedTo) {
    const templateV = Handlebars.templates['TeacherProposalMessageForm.tmpl'];
    const author = $.parseJSON($('body').data('userAuthor'));
    author.teacherScreenName = teacherScreenName;
    const context = {
        id: idOfMessageBeingRepliedTo,
        nameOfUserBeingRepliedTo: nameOfUserBeingRepliedTo,
        author: author,
    };
    context.teacherResponse = true;
    const htmlV = templateV(context);
    $(container).after(htmlV);
    $('.js-teacher-message-form-' + idOfMessageBeingRepliedTo + ' .js-publish').on('click', function (e) {
        const id = $(e.target).data('id');
        publishTeacherMessage(id);
        e.preventDefault();
    });
    $('.js-teacher-message-form-' + idOfMessageBeingRepliedTo + ' .js-preview').on('click', function (e) {
        const id = $(e.target).data('id');
        previewTeacherMessage(id);
        e.preventDefault();
    });
    $('.js-teacher-message-form-' + idOfMessageBeingRepliedTo + ' .js-edit').on('click', function (e) {
        const id = $(e.target).data('id');
        editTeacherMessage(id);
        e.preventDefault();
    });
    $('.js-teacher-message-form-' + idOfMessageBeingRepliedTo + ' .js-discard').on('click', function (e) {
        const id = $(e.target).data('id');
        discardTeacherMessage(id);
        e.preventDefault();
    });
    $(container).hide();
}

function renderProposalMessageFacebookShare(parentMessageId) {
    $('#pm' + parentMessageId + ' .activity-item').append('<div id="reply-button-facebook-share-' + parentMessageId + '"></div>');
    ReactDOM.render(
        // We'd been referencing dc.common.FacebookLink here,
        // and I think that reference was broken by
        // https://github.com/donorsChoose/donorschoose-web/commit/d52a0d5093826d101b3626f8ee209003b85eee0f
        // That leaves me wondering whether this code is actually exercised
        React.createElement(FacebookLink, {
            urlToShare: proposalURL,
            getTrackingLink: getTrackingLink,
            facebookAppId: facebookAppId,
            onFacebookClick: () => {},
            pageName: pageName + '_donationTY',
            className: 'button-secondary small button-facebook',
        }, React.createElement('div', {}, 'Share your thanks on Facebook'),
        ),
        document.getElementById('reply-button-facebook-share-' + parentMessageId),
    );
}

function saveTeacherProposalMessageCallback(response, parentMessageId) {
    $('.loader.page-loader').remove();
    if (!response || !response.success) {
        $('#proposalMessageFormSubmissionErrors-' + parentMessageId).html(response.message);
        $('#replyLoading-' + parentMessageId).remove();
        $('#replyForm-' + parentMessageId).show();
        editTeacherMessage(parentMessageId);
    } else {
        const templateV = Handlebars.templates['proposalMessageResponse.tmpl'];
        const context = { responses: [response.data] };
        const htmlV = templateV(context);
        const replyButtonSelector = '#reply-button-' + parentMessageId;
        $(replyButtonSelector).after(htmlV);
        renderProposalMessageFacebookShare(parentMessageId);

        $('#replyForm-' + parentMessageId).remove();
        $(replyButtonSelector).remove();
    }
}

export function saveTeacherProposalMessage(args, callback, errorCallback) {
    // If a global 'proposalId' exists, use that (and the global 'pmaId' and 'pmaHash') instead of the args
    const useGlobalVars = typeof window.proposalId !== 'undefined';
    const proposalIdParam = useGlobalVars ? window.proposalId : args.proposalId;
    const pmaIdParam = useGlobalVars ? window.pmaId : args.pmaId;
    const pmaHashParam = useGlobalVars ? window.pmaHash : args.pmaHash;

    $.ajax({
        // This is a cross-origin request because the endpoint accesses user session
        url: `${secureBaseURL}internal/project/${proposalIdParam}/message/new.json`,
        type: 'GET',
        data: {
            message: args.message,
            parentMessageId: args.parentMessageId || '',
            userId: pmaIdParam || '',
            userHash: pmaHashParam || '',
        },
        // withCredentials is necessary to pass cookies, since this is a cross-origin request
        xhrFields: { withCredentials: true },
        success: callback,
    }).fail(errorCallback || function () {});
}

function saveTeacherProposalMessageForProjectPage(message, parentMessageId) {
    saveTeacherProposalMessage({ message: message, parentMessageId: parentMessageId }, function (response) {
        saveTeacherProposalMessageCallback(response, parentMessageId);
    });

    $('#replyForm-' + parentMessageId).hide();
    loader.showPageLoader();
}

function previewTeacherMessage(id) {
    const maxMessageLength = 1000;
    const form = $('#addAMessageForm-' + id)[0];
    if (form.message.value == '' || (form.message.value).indexOf('Post a reply') === 0) {
        alert('Your message appears to be blank.');
    } else if (form.message.value.length > maxMessageLength) {
        alert('Your message appears to be longer than ' + maxMessageLength + ' characters. Please make it shorter.');
    } else {
        $('#messagePreview-' + id + ' .comment').html(strip(form.message.value));
        $('#messageEdit-' + id).hide();
        $('#messagePreview-' + id).show();
        $('#submit-' + id).hide();
        $('#edit-' + id).show();
        $('#publish-' + id).show();
        $('#publish-' + id).prop('disabled', false);
        $('#pleaseReview-' + id).show();
        $('#messageTitleBar-' + id).show();
    }
}

function discardTeacherMessage(id) {
    $('#replyForm-' + id).remove();
    $('#reply-button-' + id).show();
}

function editTeacherMessage(id) {
    $('#messageEdit-' + id).show();
    $('#messagePreview-' + id).hide();
    $('#buttonList-' + id).show();
    $('#submit-' + id).show();
    $('#edit-' + id).hide();
    $('#publish-' + id).hide();
    $('#publish-' + id).prop('disabled', true);
    $('#pleaseReview-' + id).hide();
}

function publishTeacherMessage(id) {
    dcAnalytics.trackEventGA(['Proposal Message', 'Add', id]);
    $('#buttonList-' + id).hide();
    saveTeacherProposalMessageForProjectPage($('#message-' + id).val(), id);
}

$(function () {
    $('body').on('click', '#leave-message-link', function (e) {
        e.preventDefault();
        $('#leave-message-link').hide();
        $('.js-donor-comment-form').show();
        $('#message').focus();
    });
});
